import axiosIntegration from "../Common/Axios/axiosIntegration";
import axiosInstanceClient from "../Common/Axios/axiosInstanceClient";
import API from "../Common/Endpoint/serviceConstrants";

export const callGetMemberPostApi = async (payload) => {
  const { data = [] } = await axiosInstanceClient.post(API.MemberApi, payload);
  return data;
};
export const callmemberGetApi = async (payload) => {
  const { data = [] } = await axiosInstanceClient.get(API.MemberApi, {
    params: {
      memberId: payload?.memberId,
      sectionId: payload?.sectionId,
      sectionContentMasterId: payload?.sectionContentMasterId,
    },
  });
  return data;
};
